import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-outline-icon-btn',
  templateUrl: './outline-icon-btn.component.html',
  styleUrls: ['./outline-icon-btn.component.scss'],
})
export class OutlineIconBtnComponent implements OnInit {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() hasIcon: string = '';
  @Input() icon: string = '';
  @Input() active: boolean = false;
  @Input() styleClass: string = '';
  @Input() disabled: boolean = false;

  @Output() handleClick = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  onClick() {
    if (this.disabled) {
      return;
    }

    this.active = !this.active;
    this.handleClick.emit(this.active);
  }
}
